
<app-common-header></app-common-header>
<br />
<br />
<div class="container" >
  <div class="row" >
    <div class="col-md-4">
      <h1>Zip code List</h1>
    </div>
    <div class="col-md-4">
      <mat-form-field style="width: 100%;">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
      </mat-form-field>
    </div>
    <!-- <div class="col-md-3">
    <a (click)="ChangeStatus()"> <img style="cursor: pointer ;margin-top: 6px;width:40px" src="assets/images/sync-flat.svg" /></a>
    </div> -->
 
  <div class="col-md-4 ">
  
  
    <a title="Add Zipcode" class="pull-right"(click)="Redirect('')"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #0fd873;  display: inline-block;
      background: #0fd873;
      text-align: center;
      border-radius: 50%;
      width: 38px;
      height: 38px;
      cursor: pointer;" src="assets/images/plus-symbol.svg" /></a>

    
    <a  style="padding-right: 10px;" title="Delete" class="pull-right"(click)="ChangeStatus(true,'Delete')"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #ff595e;  display: inline-block;
      background: #ff595e;
      padding: 4px;
      text-align: center;
      border-radius: 50%;
      width: 38px;
      height: 38px;
      cursor: pointer;" src="assets/images/delete.svg" /></a> 

        
    <a  style="padding-right: 10px;"   (click)="exportAsXLSX()" title="Export" class="pull-right"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #ff595e;  display: inline-block;
      background: #bfbdc1;
      padding: 4px;
      text-align: center;
      border-radius: 50%;
      width: 38px;
      height: 38px;
      cursor: pointer;" src="assets/images/cloud-computing.svg" /></a>
        
    
  </div>
  
  
 
<div class=" col-md-12 card mt-2">
  <div class="table-responsive">
  <table  mat-table [dataSource]="dataSource" matSort>

<!-- Checkbox Column -->
<ng-container matColumnDef="select">
  <th mat-header-cell *matHeaderCellDef>
    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()">
    </mat-checkbox>
  </th>
  <td mat-cell *matCellDef="let row" class="pd-left">
    <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)">
    </mat-checkbox>
  </td>
</ng-container>

     <ng-container matColumnDef="Action">
      <tr>
        <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">Action</th>
      </tr>
      <tr>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="'w-130'"
          style="width: 5%"
        >
          <button
            mat-icon-button
            color="primary"
            title="Edit Contact"
            (click)="Redirect( element._id )"
            style="width: 30px !important;"
          >
            <mat-icon>edit</mat-icon> 
          </button>
        </td>
      </tr>

      <tr></tr
    ></ng-container>
    <ng-container matColumnDef="Zip">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="'w-130'">
        Zipcode
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Zip }}
      </td>
    </ng-container>
   
    <ng-container matColumnDef="Utility">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">Utility Name</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Utility }}
      </td>
    </ng-container>

    <ng-container matColumnDef="City">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">City</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.City }}
      </td>
    </ng-container>

    <ng-container matColumnDef="State">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">State</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.State }}
      </td>
    </ng-container>

   
    <ng-container matColumnDef="CreatedBy">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        Created By
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.CreatedBy  }} 
      </td>
    </ng-container>
    <ng-container matColumnDef="CreatedDateTime">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">Created Date</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.CreatedDateTime | customDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ModifiedBy">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        Modified By
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ModifiedBy }} 
      </td>
    </ng-container> 
    <ng-container matColumnDef="ModifiedDateTime">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">Modified Date</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ModifiedDateTime | customDate }}
      </td>
    </ng-container>

      <!-- ID Column -->
      

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>
  <!-- <mat-paginator #providerPaginator="matPaginator"
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
></mat-paginator> -->
<mat-paginator [pageSizeOptions]="[ 15, 50, 100,1000]" showFirstLastButtons aria-label="Select page of users"></mat-paginator>
</div>
</div>
</div>

<ng-template #StatusModel>
  <div class="modal-header py-0 px-1 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <!-- <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button> -->
      <h4
      class="utility-modal-title font20 text-center text-uppercase"
    
    >
    {{title}}
    </h4> 
   
    </div>
  </div>
  <div class="modal-body pt-0" style="text-align: center;">

    <p class="utility-sub-title font20">
    {{msg}}
    </p>
    <button type="button" *ngIf="showChangeStatusButtonInPopup" class="mr-2 mt-0 btn sectbtn brdrRadius "(click)="ChangeStatus()" >Yes, Delete</button>

    <button type="button"  class="mr-2 mt-0 btn sectbtn brdrRadius "(click)="modalRef.hide()" >{{buttontext}}</button>

  </div>
</ng-template>